export const Sizes = {
  xxs: '.4rem',
  xs: '.8rem',
  sm: '1.6rem',
  default: '2.4rem',
  md: '3.2rem',
  lg: '4.8rem',
  xlg: '6.4rem',
  xxlg: '9.6rem',
};

export const Media = {
  xs: 576,
  sm: 767,
  md: 1200,
  lg: 1199,
};

export const Widths = {
  md: '1200px',
  lg: '1080px',
};
